import { render, staticRenderFns } from "./bloodOxTrend.vue?vue&type=template&id=2615cdb4&scoped=true&"
import script from "./bloodOxTrend.vue?vue&type=script&lang=js&"
export * from "./bloodOxTrend.vue?vue&type=script&lang=js&"
import style0 from "./bloodOxTrend.vue?vue&type=style&index=0&id=2615cdb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2615cdb4",
  null
  
)

export default component.exports